module.exports = __webpack_public_path__ + "static/img/headbackground.a3eefcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharing/headbackground.png
// module id = b39B
// module chunks = 59